var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClubsFront2 = function SvgClubsFront2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 120,
    fill: "none",
    viewBox: "0 0 80 120"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5311_3751)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_5311_3751)",
    d: "M6 1.887 7.838 0l1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_5311_3751)",
    d: "m6 11.323 1.838-1.888 1.838 1.888-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_5311_3751)",
    d: "m6 20.758 1.838-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_5311_3751)",
    d: "m6 30.194 1.838-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear_5311_3751)",
    d: "m6 39.629 1.838-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_linear_5311_3751)",
    d: "m6 49.065 1.838-1.888 1.838 1.888-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint6_linear_5311_3751)",
    d: "m6 58.5 1.838-1.887L9.676 58.5l-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint7_linear_5311_3751)",
    d: "m6 67.936 1.838-1.888 1.838 1.888-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint8_linear_5311_3751)",
    d: "m6 77.371 1.838-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint9_linear_5311_3751)",
    d: "m6 86.806 1.838-1.887 1.838 1.887-1.838 1.888z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint10_linear_5311_3751)",
    d: "m6 96.242 1.838-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint11_linear_5311_3751)",
    d: "m6 105.677 1.838-1.887 1.838 1.887-1.838 1.888z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint12_linear_5311_3751)",
    d: "m6 115.113 1.838-1.887 1.838 1.887L7.838 117z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint13_linear_5311_3751)",
    d: "M15.19 1.887 17.026 0l1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint14_linear_5311_3751)",
    d: "m15.19 11.323 1.837-1.888 1.838 1.888-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint15_linear_5311_3751)",
    d: "m15.19 20.758 1.837-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint16_linear_5311_3751)",
    d: "m15.19 30.194 1.837-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint17_linear_5311_3751)",
    d: "m15.19 39.629 1.837-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint18_linear_5311_3751)",
    d: "m15.19 49.065 1.837-1.888 1.838 1.888-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint19_linear_5311_3751)",
    d: "m15.19 58.5 1.837-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint20_linear_5311_3751)",
    d: "m15.19 67.936 1.837-1.888 1.838 1.888-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint21_linear_5311_3751)",
    d: "m15.19 77.371 1.837-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint22_linear_5311_3751)",
    d: "m15.19 86.806 1.837-1.887 1.838 1.887-1.838 1.888z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint23_linear_5311_3751)",
    d: "m15.19 96.242 1.837-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint24_linear_5311_3751)",
    d: "m15.19 105.677 1.837-1.887 1.838 1.887-1.838 1.888z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint25_linear_5311_3751)",
    d: "m15.19 115.113 1.837-1.887 1.838 1.887L17.027 117z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint26_linear_5311_3751)",
    d: "M24.378 1.887 26.216 0l1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint27_linear_5311_3751)",
    d: "m24.378 11.323 1.838-1.888 1.838 1.888-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint28_linear_5311_3751)",
    d: "m24.378 20.758 1.838-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint29_linear_5311_3751)",
    d: "m24.378 30.194 1.838-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint30_linear_5311_3751)",
    d: "m24.378 39.629 1.838-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint31_linear_5311_3751)",
    d: "m24.378 49.065 1.838-1.888 1.838 1.888-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint32_linear_5311_3751)",
    d: "m24.378 58.5 1.838-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint33_linear_5311_3751)",
    d: "m24.378 67.936 1.838-1.888 1.838 1.888-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint34_linear_5311_3751)",
    d: "m24.378 77.371 1.838-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint35_linear_5311_3751)",
    d: "m24.378 86.806 1.838-1.887 1.838 1.887-1.838 1.888z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint36_linear_5311_3751)",
    d: "m24.378 96.242 1.838-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint37_linear_5311_3751)",
    d: "m24.378 105.677 1.838-1.887 1.838 1.887-1.838 1.888z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint38_linear_5311_3751)",
    d: "m24.378 115.113 1.838-1.887 1.838 1.887L26.216 117z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint39_linear_5311_3751)",
    d: "M33.568 1.887 35.405 0l1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint40_linear_5311_3751)",
    d: "m33.568 11.323 1.837-1.888 1.838 1.888-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint41_linear_5311_3751)",
    d: "m33.568 20.758 1.837-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint42_linear_5311_3751)",
    d: "m33.568 30.194 1.837-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint43_linear_5311_3751)",
    d: "m33.568 39.629 1.837-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint44_linear_5311_3751)",
    d: "m33.568 49.065 1.837-1.888 1.838 1.888-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint45_linear_5311_3751)",
    d: "m33.568 58.5 1.837-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint46_linear_5311_3751)",
    d: "m33.568 67.936 1.837-1.888 1.838 1.888-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint47_linear_5311_3751)",
    d: "m33.568 77.371 1.837-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint48_linear_5311_3751)",
    d: "m33.568 86.806 1.837-1.887 1.838 1.887-1.838 1.888z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint49_linear_5311_3751)",
    d: "m33.568 96.242 1.837-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint50_linear_5311_3751)",
    d: "m33.568 105.677 1.837-1.887 1.838 1.887-1.838 1.888z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint51_linear_5311_3751)",
    d: "m33.568 115.113 1.837-1.887 1.838 1.887L35.405 117z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint52_linear_5311_3751)",
    d: "M42.757 1.887 44.595 0l1.837 1.887-1.837 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint53_linear_5311_3751)",
    d: "m42.757 11.323 1.838-1.888 1.837 1.888-1.837 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint54_linear_5311_3751)",
    d: "m42.757 20.758 1.838-1.887 1.837 1.887-1.837 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint55_linear_5311_3751)",
    d: "m42.757 30.194 1.838-1.887 1.837 1.887-1.837 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint56_linear_5311_3751)",
    d: "m42.757 39.629 1.838-1.887 1.837 1.887-1.837 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint57_linear_5311_3751)",
    d: "m42.757 49.065 1.838-1.888 1.837 1.888-1.837 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint58_linear_5311_3751)",
    d: "m42.757 58.5 1.838-1.887 1.837 1.887-1.837 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint59_linear_5311_3751)",
    d: "m42.757 67.936 1.838-1.888 1.837 1.888-1.837 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint60_linear_5311_3751)",
    d: "m42.757 77.371 1.838-1.887 1.837 1.887-1.837 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint61_linear_5311_3751)",
    d: "m42.757 86.806 1.838-1.887 1.837 1.887-1.837 1.888z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint62_linear_5311_3751)",
    d: "m42.757 96.242 1.838-1.887 1.837 1.887-1.837 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint63_linear_5311_3751)",
    d: "m42.757 105.677 1.838-1.887 1.837 1.887-1.837 1.888z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint64_linear_5311_3751)",
    d: "m42.757 115.113 1.838-1.887 1.837 1.887L44.595 117z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint65_linear_5311_3751)",
    d: "M51.946 1.887 53.784 0l1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint66_linear_5311_3751)",
    d: "m51.946 11.323 1.838-1.888 1.838 1.888-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint67_linear_5311_3751)",
    d: "m51.946 20.758 1.838-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint68_linear_5311_3751)",
    d: "m51.946 30.194 1.838-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint69_linear_5311_3751)",
    d: "m51.946 39.629 1.838-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint70_linear_5311_3751)",
    d: "m51.946 49.065 1.838-1.888 1.838 1.888-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint71_linear_5311_3751)",
    d: "m51.946 58.5 1.838-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint72_linear_5311_3751)",
    d: "m51.946 67.936 1.838-1.888 1.838 1.888-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint73_linear_5311_3751)",
    d: "m51.946 77.371 1.838-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint74_linear_5311_3751)",
    d: "m51.946 86.806 1.838-1.887 1.838 1.887-1.838 1.888z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint75_linear_5311_3751)",
    d: "m51.946 96.242 1.838-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint76_linear_5311_3751)",
    d: "m51.946 105.677 1.838-1.887 1.838 1.887-1.838 1.888z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint77_linear_5311_3751)",
    d: "m51.946 115.113 1.838-1.887 1.838 1.887L53.784 117z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint78_linear_5311_3751)",
    d: "M61.135 1.887 62.973 0l1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint79_linear_5311_3751)",
    d: "m61.135 11.323 1.838-1.888 1.838 1.888-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint80_linear_5311_3751)",
    d: "m61.135 20.758 1.838-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint81_linear_5311_3751)",
    d: "m61.135 30.194 1.838-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint82_linear_5311_3751)",
    d: "m61.135 39.629 1.838-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint83_linear_5311_3751)",
    d: "m61.135 49.065 1.838-1.888 1.838 1.888-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint84_linear_5311_3751)",
    d: "m61.135 58.5 1.838-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint85_linear_5311_3751)",
    d: "m61.135 67.936 1.838-1.888 1.838 1.888-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint86_linear_5311_3751)",
    d: "m61.135 77.371 1.838-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint87_linear_5311_3751)",
    d: "m61.135 86.806 1.838-1.887 1.838 1.887-1.838 1.888z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint88_linear_5311_3751)",
    d: "m61.135 96.242 1.838-1.887 1.838 1.887-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint89_linear_5311_3751)",
    d: "m61.135 105.677 1.838-1.887 1.838 1.887-1.838 1.888z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint90_linear_5311_3751)",
    d: "m61.135 115.113 1.838-1.887 1.838 1.887L62.973 117z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint91_linear_5311_3751)",
    d: "M70.324 1.887 72.162 0 74 1.887l-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint92_linear_5311_3751)",
    d: "m70.324 11.323 1.838-1.888L74 11.323l-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint93_linear_5311_3751)",
    d: "m70.324 20.758 1.838-1.887L74 20.758l-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint94_linear_5311_3751)",
    d: "m70.324 30.194 1.838-1.887L74 30.194l-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint95_linear_5311_3751)",
    d: "m70.324 39.629 1.838-1.887L74 39.629l-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint96_linear_5311_3751)",
    d: "m70.324 49.065 1.838-1.888L74 49.065l-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint97_linear_5311_3751)",
    d: "m70.324 58.5 1.838-1.887L74 58.5l-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint98_linear_5311_3751)",
    d: "m70.324 67.936 1.838-1.888L74 67.936l-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint99_linear_5311_3751)",
    d: "m70.324 77.371 1.838-1.887L74 77.37l-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint100_linear_5311_3751)",
    d: "m70.324 86.806 1.838-1.887L74 86.806l-1.838 1.888z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint101_linear_5311_3751)",
    d: "m70.324 96.242 1.838-1.887L74 96.242l-1.838 1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint102_linear_5311_3751)",
    d: "m70.324 105.677 1.838-1.887L74 105.677l-1.838 1.888z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint103_linear_5311_3751)",
    d: "m70.324 115.113 1.838-1.887L74 115.113 72.162 117z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint104_linear_5311_3751)",
    d: "M48.475 19.141c-5.344-5.283-14.106-5.283-19.45 0L16.274 31.75a4.33 4.33 0 0 0 0 6.196L28.63 50.163c.559.553.872 1.298.872 2.073 0 2.647-3.302 3.961-5.211 2.074L12.115 42.27c-1.782-1.76-4.702-1.76-6.483 0l-12.97 12.823c-5.216 5.159-5.216 13.43 0 18.588l12.97 12.823c1.78 1.761 4.701 1.761 6.483 0l13.601-13.448c3.436-3.398 8.133-5.311 13.034-5.311s9.597 1.913 13.034 5.31l13.601 13.449c1.782 1.761 4.702 1.761 6.483 0l12.97-12.823c5.216-5.158 5.216-13.43 0-18.587L71.867 42.27c-1.78-1.761-4.701-1.761-6.483 0L53.21 54.309c-1.909 1.888-5.212.574-5.212-2.073 0-.776.314-1.52.873-2.074l12.356-12.216a4.33 4.33 0 0 0 0-6.196z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint105_linear_5311_3751)",
    d: "M35.639 87.601c1.749-1.596 4.473-1.596 6.222 0l9.127 8.33c3.003 2.74 1.008 7.64-3.111 7.64H29.623c-4.119 0-6.114-4.9-3.111-7.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M42.89 42.614a5.494 5.494 0 0 0-7.78 0l-5.1 5.135a1.787 1.787 0 0 0 0 2.523l4.942 4.976c.224.225.349.529.349.845 0 1.078-1.321 1.613-2.085.844l-4.87-4.903a1.83 1.83 0 0 0-2.593 0l-5.188 5.222a5.36 5.36 0 0 0 0 7.57l5.188 5.223c.712.717 1.88.717 2.593 0l5.44-5.477A7.35 7.35 0 0 1 39 62.409c1.96 0 3.839.78 5.214 2.163l5.44 5.477c.713.717 1.88.717 2.593 0l5.188-5.222a5.36 5.36 0 0 0 0-7.57l-5.188-5.223a1.83 1.83 0 0 0-2.593 0l-4.87 4.903c-.764.769-2.085.233-2.085-.845 0-.316.126-.619.35-.844l4.942-4.975c.695-.7.695-1.824 0-2.524z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M37.755 70.496c.7-.65 1.79-.65 2.49 0l3.65 3.392c1.201 1.117.403 3.112-1.244 3.112h-7.302c-1.647 0-2.445-1.995-1.244-3.112z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_5311_3751",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_5311_3751",
    x1: 38.75,
    x2: 38.75,
    y1: 6.395,
    y2: 112.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E8FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_5311_3751",
    x1: 38.75,
    x2: 38.75,
    y1: 6.395,
    y2: 112.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E8FA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5311_3751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 120,
    fill: "#fff",
    rx: 8
  })))));
};
export default SvgClubsFront2;